import React, { Component } from 'react'
import PointsOfActionCase from './PointsOfActionCase'
import {POINTS_OF_ACTION_CASE_QUERY, UPDATE_POINTS_OF_ACTION_CASE} from "../../queries/Queries"
import { IconButton } from '@mui/material';
import { FaLockOpen, FaLock, FaSave } from "react-icons/fa";
import { AUTH_TOKEN } from '../../constants';
import CircularProgressIndicator from '../elements/CircularProgressIndicator';
import { useMutation, useQuery } from '@apollo/client';
import { flattenStrapiData } from '../../utils/utilities';

class PointsOfActionCaseList extends Component {
  state = {
    locked: true,
    error: ""
  }

  constructor(props) {
    super(props)
    this.handleError = this.handleError.bind(this)
  }

  handleLockChange(e) {
    this.setState({locked: !this.state.locked});
  }

  handleError(error) {
    alert(error)
  }

  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    
    if(!token) {
      return(
        <div>
          <span className="Error">You must be loged in first</span>
        </div>
      )
    }

    return (
      <div>
        <IconButton onClick={this.handleLockChange.bind(this)} >{this.state.locked ? <FaLock/> : <FaLockOpen/> }</IconButton>
        <br/>
        <div><span className="error">{this.state.error}</span></div>
        <GetList
          tocken={token}
          locked={this.state.locked}
          handleError={this.handleError.bind(this)}
        />
      </div>
    )
  }
}

function GetList({locked, token, handleError}) {
  const {data, loading, error, refetch} = useQuery(POINTS_OF_ACTION_CASE_QUERY)
  
  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) return(<span className="error">{error.message}</span>)
  
  let pointsOfActionCases = data?.pointsOfActionCases?.data

  return (
    <table className="table table-bordered">
      <tbody>
        <tr>
          <td><h4>Id</h4></td>
          <td><h4>ActionCase</h4></td>
          <td><h4>PointValue</h4></td>
          {token && !locked &&
          <td><h4>Edit/Add</h4></td>}
        </tr>
        {pointsOfActionCases.map(pointsOfActionCase =>  {
          pointsOfActionCase = flattenStrapiData(pointsOfActionCase)
          return <PointsOfActionCase 
          key={pointsOfActionCase.id} 
          locked={locked} 
          pointsOfActionCase={pointsOfActionCase} 
          defineError={handleError}>
            <Update refetch={() => refetch()}/>
          </PointsOfActionCase>
        })}
      </tbody>
    </table>
  )
}

function Update({id, state, refetch}) {
  const [updatePointsOfAction, {loading, error}] = useMutation(UPDATE_POINTS_OF_ACTION_CASE)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) alert("Update Mutation Error: "+ error.message)
  return (
      <IconButton onClick={e => updatePointsOfAction({ variables: {id: id, points_value: parseInt(state.points_value)} })
      .then(data => refetch())
      .catch(e => alert("Execute Update Mutation Error: "+e))}><FaSave/></IconButton>
  )
}

export default PointsOfActionCaseList